import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountService } from '../../../../Services/Accounts/account.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { AuthService } from '../../../../Services/auth.service';

@Component({
  selector: 'app-user-accounts',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './user-accounts.component.html',
  styleUrl: './user-accounts.component.css'
})
export class UserAccountsComponent implements OnInit {

  accounts: any[] = [];
  currentFirmId: number | null = null;

  constructor(
    private accountService: AccountService,
    private firmSelectionService: FirmSelectionService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.firmSelectionService.selectedFirmName$.subscribe(firm => {
      this.currentFirmId = firm ? firm.id : null;

      if (this.currentFirmId) {
        this.loadUserAccounts();
      }
    });
  }

  loadUserAccounts() {
    if (!this.currentFirmId) return;

    this.accountService.getUserAccounts({
      firm_id: this.currentFirmId
    }).subscribe({
      next: (res: any) => {
        this.accounts = res.data || [];
      },
      error: (err) => {
        console.error('Error fetching user accounts:', err);
      }
    });
  }
}